import { Avatar } from '@calendly/ui/components/avatar';
import { Item, PopupDropdownMenu } from '@calendly/ui/components/menu';
import { OptionUI, OptionsUI } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FullStoryExclude, FullStoryMask } from '../../../../../shared/fullstory_privacy';
const styledAvatarCss = "s1tfscuf";
const StyledAvatar = forwardRef((props, ref) => <Avatar ref={ref} {...props} className={classNames(styledAvatarCss, props.className)} />);
const infoWrapperCss = "isbvay6";
const InfoWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(infoWrapperCss, props.className)} />;
});
const emailWrapperCss = "e1956nss";
const EmailWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emailWrapperCss, props.className)} />;
});
const dropdownMenuCss = "d16o6r98";
const DropdownMenu = forwardRef((props, ref) => <PopupDropdownMenu ref={ref} {...props} data-component="organizer-option-list" className={classNames(dropdownMenuCss, props.className)} />);
const MobileDropdown = ({
  organizerOptions,
  updateOrganizer
}) => <OptionsUI>
    {organizerOptions.map(option => <OptionUI aria-label={option.name}>
          <OrganizerOption key={option.email} membershipOption={option} updateAction={updateOrganizer} />
        </OptionUI>)}
  </OptionsUI>;
const OrganizerOption = ({
  membershipOption,
  updateAction
}) => <Item onClick={() => updateAction(membershipOption)}>
    <FullStoryExclude>
      <StyledAvatar size="small" src={membershipOption.avatar_url} letter={membershipOption.avatar_letter} alt={membershipOption.name} />
    </FullStoryExclude>
    <InfoWrapper>
      <BodyText>
        <FullStoryMask>{membershipOption.name}</FullStoryMask>
      </BodyText>
      <EmailWrapper>
        <BodyText>
          <FullStoryMask>{membershipOption.email}</FullStoryMask>
        </BodyText>
      </EmailWrapper>
    </InfoWrapper>
  </Item>;
export const OrganizerOptionList = ({
  organizerOptions,
  updateOrganizer
}) => {
  const isPhone = useDeviceType('isPhone');
  if (isPhone) {
    return <MobileDropdown organizerOptions={organizerOptions} updateOrganizer={updateOrganizer} />;
  }
  return <DropdownMenu>
      {organizerOptions.map(option => <OrganizerOption key={option.email} membershipOption={option} updateAction={updateOrganizer} />)}
    </DropdownMenu>;
};

require("./organizer_option_list.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./organizer_option_list.js");